import React from 'react';
import { map } from 'lodash';

import useMobileTopMatchItem from './useMobileTopMatchItem';
import matchList from 'modules/match-list';
import { MultiCarousel } from 'components';
import './mobileTopMatchItem.scss';

const {
    components: { SportEventRow },
} = matchList;

interface Props {
    zoneId: string;
    sportEventIds: Set<string>;
    slideWidth: number;
}

const MobileTopMatchItem: React.FC<Props> = ({
    zoneId,
    sportEventIds,
    slideWidth,
}) => {
    const { matchesIds, title } = useMobileTopMatchItem({
        zoneId,
        sportEventIds,
    });

    if (!matchesIds.length) return null;

    return (
        <div styleName="container">
            <div styleName="title">{title}</div>

            <div styleName="carousel">
                <MultiCarousel
                    slideWidth={slideWidth}
                    extraSlides={1}
                    centerMode={false}
                    withNavigation={true}
                >
                    {map(matchesIds, matchId => (
                        <SportEventRow
                            key={matchId}
                            matchId={matchId}
                            prevMatchId={undefined}
                        />
                    ))}
                </MultiCarousel>
            </div>
        </div>
    );
};

export default React.memo(MobileTopMatchItem);
